import { relayStylePagination } from '@apollo/client/utilities'

const dateTypePolicy = {
  merge: (_, incoming) => {
    if (incoming === null || incoming === undefined) {
      return incoming
    } else if (incoming instanceof Date) {
      return incoming
    } else {
      return new Date(incoming)
    }
  },
}

const JSONTypePolicy = {
  read: (_, incoming) => {
    if (typeof incoming === 'string') {
      try {
        return JSON.parse(incoming)
      } catch {
        return undefined
      }
    } else {
      return incoming
    }
  },
  merge: (_, incoming) => {
    try {
      return JSON.parse(incoming)
    } catch {
      return null
    }
  },
}

const connectionTypePolicy = relayStylePagination()

export { JSONTypePolicy, connectionTypePolicy, dateTypePolicy }
